import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { class: "container text-center" }
const _hoisted_2 = { class: "row my-5 align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto p-3",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "m-4" }
const _hoisted_6 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('SOLUTIONS.PRODUCT.TITLE')), 1),
    _createElementVNode("h6", null, _toDisplayString(_ctx.$t('SOLUTIONS.PRODUCT.SUBTITLE')), 1),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('SOLUTIONS.PRODUCT.PRODUCTS'), (product) => {
          return (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, _toDisplayString(product), 1)
          ]))
        }), 256))
      ])
    ])
  ]))
}